export default "__VITE_ASSET__294301e3__"